import styled from "styled-components";

// Removes the default Source Web padding from the Toggle.
export const StatusTogglePaddingStyles = styled.div`
  div {
    padding: 0 0 0 0;
  }
`;

export const CustomerCodeMessage = styled.div`
  #pidMessage {
    color: grey !important;
    margin-top: -32px !important;
  }
`;
